import { cn } from '../../lib/utils';
import MessageStatus from './MessageStatus';

interface MessageTimestampProps {
  date: string;
  time: string;
  isUser: boolean;
  seen?: boolean;
  received?: boolean;
  isSilent: boolean;
}

function MessageTimestamp({ date, time, isUser, seen, received, isSilent }: MessageTimestampProps) {
  return (
    <div className={cn('flex items-center', isUser ? 'justify-end' : 'justify-start')}>
      <span className="mt-2 ml-1 text-[10px] text-gray-500">
        <span className="mr-1">{date}</span>
        {time}
      </span>
      {isUser && <MessageStatus seen={seen} received={received} isSilent={isSilent} />}
    </div>
  );
}

export default MessageTimestamp;
